import { render, staticRenderFns } from "./help.vue?vue&type=template&id=b144e124"
import script from "./help.vue?vue&type=script&lang=js"
export * from "./help.vue?vue&type=script&lang=js"
import style0 from "./help.vue?vue&type=style&index=0&id=b144e124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports